import { Grid, Stack } from '@mui/material';
import React from 'react';
import Packet from './packet/Packet';
import FlightData from './flightData/FlightData';
import Printer from './printerModule/Printer';

const Content: React.FC = () => {
  return (
    <Grid
      container
      pt={6}
      pb={{
        xs: 4,
        md: 10,
      }}
      pl={{
        xs: 4,
        md: 10,
      }}
      pr={{
        xs: 4,
        md: 10,
      }}
      rowSpacing={4}
    >
      <Grid item xs={12}>
        <Stack
          width="100%"
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          spacing={4}
        >
          {/* Printer Component */}
          <Printer />

          {/* Packet Component */}
          <Packet />
        </Stack>
      </Grid>

      <Grid item xs={12}>
        {/* Flight Data Component */}
        <FlightData />
      </Grid>
    </Grid>
  );
};

export default Content;
